<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <Header/>

      
      <b-row class="titulos">
        <b-col class="seccionTitulo">
          <b-icon icon="file-earmark-text-fill" class="mLeft"></b-icon>
          <div class="headerTxt mLeft">Configuración historia clínica</div>
        </b-col>
        <b-col class="seccionCodigo">
          <div>Admin_HC</div>
        </b-col>
      </b-row>

          <b-container fluid>
            <b-row  class="text-left mt-2">
              <b-col cols="3"> Búsqueda por dentición</b-col>
                  <b-col cols="1">
                  <b-form-radio v-if="$localStorageService.can('HC_admin_nino')" v-model="selected"  name="some-radios" @input="traerClasificaciones" value="1">Infantil</b-form-radio>
                  </b-col>
                  <b-col cols="1">
                  <b-form-radio v-if="$localStorageService.can('HC_admin_adulto')" v-model="selected"   @input="traerClasificaciones" name="some-radios" value="2">Adulto</b-form-radio>
                  </b-col>
              <b-col cols="6"></b-col>
                  <b-col cols="1">
                  <b-button v-if="$localStorageService.can('HC_admin_nuevo')" v-b-tooltip.hover.right.v-primary title="Agregar categoría" variant="outline-info" pill
                            @click="verDetalleCat(datosModal, 1)"
                  >
                    <b-icon  icon="plus-circle-fill"></b-icon>
                  </b-button>
                  </b-col>

            </b-row>
            <b-row class="text-center mt-2">
              <b-col v-if="cargandoClasificaciones">
                <b-spinner  variant="primary" ></b-spinner>
              </b-col>
              <b-col v-else>
                  <b-table
                      id="cl"
                      thead-tr-class="columnas"
                      :items="listaClasificaciones"
                      :fields="encabezados"
                      :per-page="registrosPorPagina"
                      :current-page="paginaActual"
                      responsive
                  >
                    <template v-slot:cell(esEmergencia)="row">
                      <b-icon variant="success" v-if="row.item.esEmergencia"  icon="check-circle"></b-icon>
                      <b-icon variant="danger" v-else icon="x-circle"></b-icon>
                    </template>
                    <template v-slot:cell(Acciones)="row">
                      <b-button-group>
                        <b-button pill v-if="row.item.registroActivo && $localStorageService.can('HC_admin_preguntas')" class=" m-1" size="sm"
                                  v-b-popover.hover.auto title="Preguntas"
                                  variant="outline-success"
                                  @click="abrirEnfermedades(row.item)"
                        ><b-icon  icon="blockquote-left"></b-icon>
                        </b-button>
                        <b-button pill v-if="row.item.registroActivo && $localStorageService.can('HC_admin_editar')" class=" m-1" size="sm"
                                  v-b-popover.hover.auto title="Editar"
                                  variant="outline-warning"
                                  @click="verDetalleCat(row.item, 2)"
                        ><b-icon  icon="pencil-square"></b-icon>
                        </b-button>
                        <b-button v-if="row.item.registroActivo && $localStorageService.can('HC_admin_inactivar')" pill class=" m-1" size="sm"
                                  v-b-popover.hover.auto title="Inactivar"
                                  variant="outline-danger"
                                  @click="cambiarEstatusRegistro(row.item.idClasificacionSistemica, false, 'inactivar')"
                          ><b-icon  icon="trash"></b-icon>
                        </b-button>
                        <b-button v-else pill class="m-1"
                                  v-b-popover.hover.auto title="Activar"
                                  size="sm" variant="outline-info"
                                  @click="cambiarEstatusRegistro(row.item.idClasificacionSistemica, true, 'activar')"
                        ><b-icon  icon="arrow-counterclockwise"/>
                        </b-button>
                      </b-button-group>

                    </template>
                  </b-table>
                  <b-pagination
                      v-if="listaClasificaciones.length > 10"
                      align="center"
                      v-model="paginaActual"
                      :total-rows="listaClasificaciones.length"
                      :per-page="registrosPorPagina"
                      aria-controls="my-table1"
                  ></b-pagination>
                </b-col>
          </b-row>
          </b-container>

    <b-modal id="modal-1" :title="titulo" v-model="showDatos" >
      <label> Descripción clasificación: <validacion/> </label>
      <b-form-input
          v-model="datosModal.descripcion"
          type="text"
          id="desc"
          minlength="3"
          placeholder="Clasificación"
          :state="datosModal.descripcion != null && datosModal.descripcion !== '' "
          required
      ></b-form-input>
      <b-row  class="text-center mt-4">
        <b-col cols="4"><label> Tipo dentición: <validacion/> </label>
          <b-form-radio v-model="datosModal.idDenticion"  name="some-r1" value="1">Infantil</b-form-radio>

          <b-form-radio v-model="datosModal.idDenticion"  name="some-r1" value="2">Adulto</b-form-radio>
        </b-col>
        <b-col cols="4">
          <label> Orden: <validacion/> </label>
          <b-form-input
              v-model="datosModal.orden"
              type="number"
              id="desc"
              min="1" max="999"
              placeholder="Orden"
              :state="datosModal.orden != null && datosModal.orden !== '' "
              required
              @keypress="onlyNumber"
          ></b-form-input>
        </b-col>
        <b-col cols="4">
          <label> Aplica en Hc Emergencia </label>
          <b-form-checkbox
              name="datosModal.esEmergencia"
              v-model="datosModal.esEmergencia"
          >
          </b-form-checkbox>
        </b-col>
      </b-row>
      <label class=" mt-4"> Sino aplica un orden o el orden es repetido, el formulario en la historia clínica se ordenará por fecha modificación. </label>

      <template #modal-footer>
        <div >

          <b-button v-if="!loaderModal"
              variant="primary"
              size="sm"
              class="ml-1"
              @click="guardarClasificacion()"
          >
            Guardar
          </b-button>
          <b-button variant="primary" v-show="loaderModal" disabled>
            <b-spinner small></b-spinner>
            Cargando...
          </b-button>

          <b-button
              variant="secondary"
              size="sm"
              class=" ml-1"
              @click="cerrarModal()"
          >
            Cerrar
          </b-button>



        </div>
      </template>
    </b-modal>


  </div>
</template>

<script>
import Header from "@/components/Header";
export default {
  name: "ConfiguracionFormularioHc.",
  components: {  Header},
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,

    cargandoClasificaciones: true,
    listaClasificaciones:[],
    encabezados: [
      {key: "idClasificacionSistemica", label: "Id clasificacion", sortable: true},
      {key: "descripcion", label: "Descripción", sortable: true},
      {key: "orden", label: "Orden", sortable: true},
      {key: "denticion", label: "Dentición", sortable: true},
      {key: "esEmergencia", label: "Aplica en Hc Emergencia", sortable: true},
      "Acciones",
    ],
    registrosPorPagina: 10,
    paginaActual:1,
    selected: 0,
    showDatos: false,
    datosModal: {
      idClasificacionSistemica: null,
      descripcion: null,
      idDenticion: 0,
      orden:0,
      esEmergencia: false,
    },
    titulo: null,
    loaderModal: false,
  }),
  created() {
    this.debug = this.$localStorageService.getDebug();
    this.traerClasificaciones();
  },
  methods:{
    guardarClasificacion(){


      if (this.datosModal.descripcion === null || this.datosModal.descripcion === ''
          || this.datosModal.orden === null || this.datosModal.orden === ''){
        this.$swal.fire({
          icon: 'error',
          text: "Por favor llene los campos obligatorios",
          showConfirmButton: false,
          timer: 1500,
        });
        return;
      }
      this.loaderModal = true;
      this.$http.post(this.$api + 'hc/guardarEditarClasificacion', this.datosModal).then(respuesta => {
        if (respuesta.data.data){

          this.$swal.fire({
            icon: 'success',
            text: "Se registró correctamente"
          });
        }
      }).finally(() => {
        this.traerClasificaciones();
        this.showDatos = false
        this.loaderModal = false;

      })

    },
    cerrarModal(){

      this.showDatos = false;
    },
    verDetalleCat(datos, guardar){
      this.showDatos = true;
      if (guardar === 1){
        this.datosModal = {
            idClasificacionSistemica: null,
              descripcion: null,
              idDenticion: 2,
              orden:0,
              esEmergencia : false
        }
      }else {
        this.datosModal = datos;
        this.titulo = datos.descripcion
      }

    },
    traerClasificaciones() {
      this.paginaActual = 1;
      this.cargandoClasificaciones = true;
      const params = {
        idDenticion: this.selected
      }
      let urlMedio = this.$api + "hc/obtenerClasificacionesHC";
      this.$http.post(urlMedio, params).then((response) => {
            if (response.data.data) {
              this.listaClasificaciones = response.data.data;
            }
          })
          .catch((err) => {
            this.errorMensaje(err);
          })
          .finally(() => {
            this.cargandoClasificaciones = false;
          });
    },
    cambiarEstatusRegistro(idClasificacion, estatus, texto){

      this.$swal.fire({
        title: '¿Está seguro de ' + texto + ' el registro?',
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Ok",
        cancelButtonText: "Cancelar",
        preConfirm: () => {
          this.cargandoClasificaciones = true;
          const params = {
            idClasificacionSistemica: idClasificacion,
            registroActivo: estatus,
          }
          this.$http.put(this.$api + "hc/cambiarEstatus", params )
              .then(() => {

                this.$swal.fire({
                  icon: 'success',
                  text: "Se registró correctamente"
                });

              }).finally(()=>{
            this.cargandoClasificaciones = false;
                this.traerClasificaciones();
              })
        }
      })

    },
    abrirEnfermedades(classif){
      this.$router.push({
        name: "preguntasHc",
        params: {
          idClasificacion: classif.idClasificacionSistemica,
          clasif: classif.descripcion,
          idDenticion: classif.idDenticion,
        },
      });
    },
    onlyNumber($event) {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if (keyCode < 48 || keyCode > 57) {
        $event.preventDefault();
      }
    },
  }
}
</script>

<style scoped>

</style>